import { Link } from "react-router-dom";

const ThePipsInsightsContentThree = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Empowering Every Trader</h2>
              <p>
                Every insight is curated to help you strengthen your trading
                strategy, anticipate volatility, and refine decision-making
                across all asset classes; Forex, Crypto, Stocks, and
                Commodities. Our research team distills complex market
                developments into practical, easy-to-apply guidance tailored for
                traders at every skill level. Whether you’re navigating
                fast-moving markets or planning long-term positions, each update
                equips you with the clarity needed to stay ahead. We highlight
                emerging trends, potential risks, and high-probability
                opportunities so you can act with confidence. With The Pips
                Insights, you gain a deeper understanding of market behavior and
                the tools to make smarter, more informed trading decisions every
                day.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Discover Market Updates
              </Link>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="thumb-right">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/resources/the_pips_insights/resources_insights_3.png"
                }
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    // </>
  );
};

export default ThePipsInsightsContentThree;
